import { useEffect, useState } from "react"
import { useSnackbar } from "notistack"
import { Menu, Tooltip  } from "antd"

import { notifOps, usePet, ws } from "../../modules"

const CallForPatient = ({ item, order, patient }) => {
    const [called, setCalled] = useState()
    const {enqueueSnackbar} = useSnackbar()

    const [, callPatient] = usePet('callForPatient', { id: item ?? order, type: item ? 'item' : 'order', station: localStorage.getItem('station') }, { notify: true, callback: ({ data }, notif, ops) => notif('Call has been sent, please wait for patient', ops('success')), manual: true, load: { msg: 'Sending call...' } })

    useEffect(() => {
        ws.on('audio-queue-update', data => {
            let { speech, station } = data
            let cPatient = speech.split(',')[0]
            
            if (patient?.name?.toLowerCase() === cPatient && station !== localStorage.getItem('station')) {
                setCalled(station)
                setTimeout(() => setCalled(), 60000)
            }
        })
    }, [called])

    if (!called)
        return (
            <Menu.Item style={{ backgroundColor: called ? "rgb(254,200,198)" : '' }} onClick={ () => {
                if (called) {
                    enqueueSnackbar(`${patient?.name ?? "The patient"} has just been called to ${called}`, notifOps('warning'))
                } else {
                    callPatient()
                }
            } }>Call For Patient</Menu.Item>
        )

    return (
        <Tooltip defaultVisible={ called ? true : false } title={ `${patient?.name ?? "The patient"} has just been called to ${called}` }>
            <Menu.Item style={{ backgroundColor: called ? "rgb(254,200,198)" : '' }} onClick={ () => {
                if (called) {
                    enqueueSnackbar(`${patient?.name ?? "The patient"} has just been called to ${called}`, notifOps('warning'))
                } else {
                    callPatient()
                }
            } }>Call For Patient</Menu.Item>
        </Tooltip>
    )
}

export default CallForPatient